import { render, staticRenderFns } from "./TipsInfo.vue?vue&type=template&id=625aa353&scoped=true&"
import script from "./TipsInfo.vue?vue&type=script&lang=js&"
export * from "./TipsInfo.vue?vue&type=script&lang=js&"
import style0 from "./TipsInfo.vue?vue&type=style&index=0&id=625aa353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625aa353",
  null
  
)

export default component.exports